export { getStructuredUserDetailsPage, getStructuredUserDetailsResponse } from './user';
